<template>
  <div class="flex items-center gap-1 px-3 py-2" role="status" aria-label="Bottle Bot is typing">
    <span class="h-2 w-2 animate-bounce rounded-full bg-catering-ink-400" style="animation-delay: 0ms" />
    <span class="h-2 w-2 animate-bounce rounded-full bg-catering-ink-400" style="animation-delay: 120ms" />
    <span class="h-2 w-2 animate-bounce rounded-full bg-catering-ink-400" style="animation-delay: 240ms" />
  </div>
</template>
